import React, { ReactNode } from 'react'

import { ActivityHistoryTypeEnum } from '../activityHistoryTypes'
import { Box, Flex, Link as ChakraLink, Text } from 'front-end/src/components'
import { brandColors } from '../../../../../shared/basicPalette'
import IconPlus from '../../../components/common/icon/IconPlusInCircle'
import IconEvent from '../../../components/common/icon/IconEvent'
import IconDoc from '../../../components/common/icon/IconDoc'
import { IconNewTab } from '../../../components/common/icon/IconNewTab'
import { StatusArchivedGrey } from '../../../components/common/status/Status'
import IconDownload from 'front-end/src/components/common/icon/IconDownload'
import { useLooopTheme } from 'front-end/src/public-api/hooks/useLooopTheme'

interface ActivityNameInfoProps {
  typename: ActivityHistoryTypeEnum
  title?: string
  linkUrl?: string
  downloadLink?: string
  children: ReactNode
  isArchived?: boolean
}

const HISTORY_ITEM_ICONS = {
  [ActivityHistoryTypeEnum.CPDManualEntryModel]: IconPlus,
  [ActivityHistoryTypeEnum.UserEventModel]: IconEvent,
  [ActivityHistoryTypeEnum.TopicEnrolmentModelAsStudent]: IconDoc
}

const ActivityNameInfo = ({
  typename,
  title,
  children,
  linkUrl,
  isArchived,
  downloadLink
}: ActivityNameInfoProps) => {
  const { theme } = useLooopTheme()
  const Icon = HISTORY_ITEM_ICONS[typename]
  const linkStyles = {
    ml: '8px',
    height: '14px',
    opacity: '0',
    transition: 'opacity ease 0.1',
    _focus: {
      opacity: 1
    }
  }

  return (
    <Flex>
      <Icon
        w="28px"
        h="auto"
        mr="12px"
        mt="4px"
        mb="4px"
        fontSize="28px"
        color={theme.colors.grey[300]}
        alignSelf="center"
      />
      <Box>
        <Flex alignItems="center">
          <Text
            as="h3"
            fontSize="16px"
            lineHeight="24px"
            color={brandColors.grey.dark}
            opacity={isArchived ? 0.7 : undefined}
            wordBreak="break-all"
            noOfLines={2}
          >
            {title}
          </Text>
          {isArchived && <StatusArchivedGrey ml="8px" />}
          {downloadLink && (
            <ChakraLink href={downloadLink} download {...linkStyles}>
              <IconDownload height="14px" width="auto" />
            </ChakraLink>
          )}
          {linkUrl && !isArchived && (
            <ChakraLink to={linkUrl} {...linkStyles}>
              <IconNewTab
                height="14px"
                width="auto"
                color={brandColors.grey.mid}
              />
            </ChakraLink>
          )}
        </Flex>
        {children}
      </Box>
    </Flex>
  )
}

export default ActivityNameInfo
